import { useCallback, useRef } from 'react';

export type AgentResponseSelection =
  | {
      action: 'toggle';
      index: number;
      label: string;
    }
  | {
      action: 'reset';
    };

// onSetAgentResponse must be memoized
export function useAgentResponseSelector(onSetAgentResponse?: (response: string) => void): {
  onTaskAction: (params: AgentResponseSelection) => void;
} {
  const selectedResponseRef = useRef<Record<string, string>>({});

  const onTaskAction = useCallback(
    (params: AgentResponseSelection) => {
      if (params.action === 'toggle') {
        const { index, label } = params;
        const next = { ...selectedResponseRef.current };
        if (!next[index]) {
          next[index] = label;
        } else {
          delete next[index];
        }
        selectedResponseRef.current = next;
        onSetAgentResponse?.(Object.values(next).join(', '));
      } else if (params.action === 'reset') {
        selectedResponseRef.current = {};
        onSetAgentResponse?.('');
      }
    },
    [onSetAgentResponse],
  );

  return { onTaskAction };
}
